/**
 * Actividad del equipo en la entrada (GEN-PX-010, spec §4.4). Solo con lo que el
 * front ya tiene: `descriptor.chats` (agentes_en_chat y updated_at). Sin llamadas
 * nuevas ni lógica de negocio: cuenta y ordena.
 */

export const DIAS_ACTIVIDAD = 7
export const MAX_TARJETAS = 10

const MS_DIA = 24 * 60 * 60 * 1000

// Conversaciones del usuario con el agente en los últimos 7 días. Un chat cuenta
// si el agente habló en él (`agentes_en_chat`, por nombre: el digest no trae id)
// o si fue quien respondió el último turno (`agente_ultimo.id`, GEN-195).
export function conversacionesRecientes(agent, chats = [], ahora = Date.now()) {
  const desde = ahora - DIAS_ACTIVIDAD * MS_DIA
  return chats.filter(c => {
    const t = Date.parse(c?.updated_at ?? '')
    if (!Number.isFinite(t) || t < desde) return false
    const hablo = (c.agentes_en_chat ?? []).some(a => a?.nombre === agent.nombre)
    return hablo || (c.agente_ultimo?.id != null && c.agente_ultimo.id === agent.id)
  }).length
}

// Mapa id -> n.º de conversaciones recientes.
export function actividadPorAgente(agents = [], chats = [], ahora = Date.now()) {
  return new Map(agents.map(a => [a.id, conversacionesRecientes(a, chats, ahora)]))
}

// Hasta `max` agentes: si hay más, los de más conversaciones en 7 días; a igualdad,
// el orden del descriptor. Devuelve los agentes en su orden ORIGINAL (así el
// tablero conserva las columnas por departamento y el líder primero).
export function masActivos(agents = [], actividad, max = MAX_TARJETAS) {
  if (agents.length <= max) return agents
  const elegidos = new Set(
    agents
      .map((a, i) => ({ a, i, n: actividad.get(a.id) ?? 0 }))
      .sort((x, y) => y.n - x.n || x.i - y.i)
      .slice(0, max)
      .map(x => x.a),
  )
  return agents.filter(a => elegidos.has(a))
}

export const textoActividad = n => (n > 0 ? `en ${n} ${n === 1 ? 'conversación' : 'conversaciones'}` : 'disponible')
